<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="24" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="24" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button @click="(table.where = { type: 2 }) && $refs.table.reload()">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column type="index" width="45" align="center" />
        <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
        <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
        <el-table-column prop="score" label="得分" show-overflow-tooltip align="center" />
        <el-table-column prop="rank" label="排名" show-overflow-tooltip align="center" />
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-link @click="viewDetail(row)" icon="el-icon-view" type="primary" :underline="false">详情</el-link>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <!--详情-->
    <el-dialog title="详情" :visible.sync="showDetail" width="980px" :destroy-on-close="true" :lock-scroll="false">
      <ele-data-table ref="tableDetail" :config="tableDetail" row-class-name="custom-row-class" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column type="index" width="45" align="center" />
          <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
          <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
          <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
          <el-table-column prop="accessProjectName" label="项目" show-overflow-tooltip align="center" />
          <el-table-column prop="accessItemName" label="细则" show-overflow-tooltip align="center" />
          <el-table-column prop="itemType" label="属性" show-overflow-tooltip align="center" width="60">
            <template slot-scope="{ row }">
              {{ row.itemType == 1 ? '加分' : row.itemType == 2 ? '减分' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="studentScore" label="分值" show-overflow-tooltip align="center" width="50" />
          <el-table-column prop="photos" label="照片" show-overflow-tooltip align="center" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.photos == null ? 'info' : ''" @click="row.photos == null ? '' : viewPhotos(row.photos)">
                {{ row.photos == null ? '暂无' : '查看' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDay" label="录入日期" show-overflow-tooltip align="center" />
          <el-table-column prop="createUser" label="录入人" show-overflow-tooltip align="center" />
          <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center" />
        </template>
      </ele-data-table>
    </el-dialog>
    <!--照片-->
    <el-dialog title="照片" :visible.sync="showImage" width="700px" :destroy-on-close="true" :lock-scroll="false">
      <el-carousel indicator-position="outside" height="500px">
        <el-carousel-item v-for="item in imageList" :key="item">
          <el-image style="width: 100%; height: 500px" :src="item" fit="fill"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
  import { selectionList } from '@/config/fengyi/examine';

  export default {
    name: 'Class',
    data() {
      return {
        table: {
          // 表格配置
          url: '/fyAccess/getClassAccessPage',
          method: 'GET',
          where: {
            type: 2,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        tableDetail: {
          // 表格配置
          url: '/fyAccess/getAccessDetail',
          method: 'GET',
          where: {
            type: 2,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        date: null,
        showDetail: false,
        imageList: [],
        showImage: false,
      };
    },
    created() {
      this.searchListbyType(1);
    },
    methods: {
      // 搜索下拉选
      searchListbyType(type, id) {
        let data = {
          type: type,
          id: id,
        };
        selectionList(data).then((res) => {
          if (res.data.resCode == 200) {
            if (type == 1) {
              //校部
              this.branchList = res.data.data;
            } else if (type == 2) {
              //年级
              this.gradeList = res.data.data;
            } else if (type == 3) {
              //级部
              this.subGradeList = res.data.data;
            } else if (type == 4) {
              //班级
              this.classList = res.data.data;
            }
          }
        });
      },
      handleDateChange(value) {
        this.table.where.startDay = value[0];
        this.table.where.endDay = value[1];
      },
      // 查看详情
      viewDetail(row) {
        this.showDetail = true;
        this.tableDetail.where.id = row.id;
      },
      // 查看照片
      viewPhotos(photos) {
        this.imageList = photos.split(',');
        this.showImage = true;
      },
    },
  };
</script>

<style scoped></style>
